import Awoods from "../index"
import $ from 'jquery'

export default class DomActions 
{
    awoods: Awoods

    constructor(awoods: Awoods)
	{
	    this.awoods = awoods
	}
	
    private foreachDom(selector: string, callback: (pathname: string, expires: number, jq: any) => void)
	{
		let that = this
		$(selector).each(function() {
			let thisthis = this as unknown as any
		    var pathname = $(thisthis).attr('pathname') ?? location.pathname
			var expires = !isNaN(parseInt($(thisthis).attr('expires')))? parseInt($(thisthis).attr('expires')) : that.awoods.opt.visit_interval as number
			
		    callback(pathname, expires, $(thisthis))
		})
	}

	/**
	 * 渲染评论数量dom，同一个页面里可以多次使用
	 * 
	 * 用法：`<span class="april-comment-count" pathname="/">xx</span>条评论`
	 * 
	 * @param selector 选择器
	 * @returns DomAction对象
	 */
    renderCommentCount(selector='.awoods-count')
	{
		this.foreachDom(selector, (pathname: string, expires: number, jq: any) => {
			this.awoods.count(pathname).then(count => jq.text(count))
		})
	    return this
	}

	/**
	 * 渲染浏览次数dom，同一个页面里可以多次使用
	 * 
	 * 用法：`<span class="april-comment-views" pathname="/">xx</span>次浏览`
	 * @param selector 
	 * @returns 
	 */
    renderPageViews(selector='.awoods-views')
	{
		this.foreachDom(selector, (pathname: string, expires: number, jq: any) => {
			this.awoods.views(pathname).then(count => jq.text(count))
		})
	    return this
	}

	/**
	 * 渲染并记录一次浏览次数，同一个页面里不推荐多次使用相同的pathname参数
	 * 
	 * 用法：`<span class="april-comment-visit" pathname="/" expires="1800">xx</span>次浏览`
	 * @param selector 
	 * @returns 
	 */
    recordVisit(ignoreLoginState: boolean, selector='.awoods-visit')
	{
	    this.foreachDom(selector, (pathname: string, expires: number, jq: any) => {
			let loggedIn = !ignoreLoginState && this.awoods.editorComponent.$refs.profile.isLoggedIn()
			let expiresInSeconds = parseInt((new Date(Date.now() + expires * 1000).getTime() / 1000) as unknown as string)
			if(!loggedIn && this.awoods.stateData.object.visitPage(pathname, expiresInSeconds))
			{
				this.awoods.visit(pathname).then(views => jq.text(views))
			} else {
				this.awoods.views(pathname).then(count => jq.text(count))
			}
		})

	    return this
	}
}